import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const collector: ThemeUICSSObject = {
  /* PREPEND HERE */
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: '1 !important',
    minWidth: 'min(400px, calc(100vw - 52px))',
    overflow: 'hidden',
    pr: 2,

    '.collector__fields': {
      overflow: 'auto',
      gap: '8px',
      display: 'flex',
      flexDirection: 'column',
    },

    '.collector__buttons': {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'end',
      gap: 4,
    },

    '.fieldWrapper.checkbox': {
      display: 'flex',
      flexDirection: 'row-reverse',
      gap: 4,
      alignItems: 'start',
      justifyContent: 'start',
    },

    '.validationsForm': {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      overflow: 'hidden',
    },
  },

  modal: {
    '.modal__main': {},
  },
};
